module.exports = __webpack_public_path__ + "img/shizuha aki_lw.e96a1aca.png";